import { DateTime } from 'luxon'

// Get list of IANA timezones supported by the environment
const timezones =
  typeof (Intl as any).supportedValuesOf === 'function' ? (Intl as any).supportedValuesOf('timeZone') : [] // fallback to empty or static list
const timeZoneMap: Record<string, string> = {}

const timezonesWithOffset = timezones.map((tz: string) => {
  // Make sure to call the function correctly (no missing parentheses)
  const currentTime = DateTime.now().setZone(tz)
  const offsetInMinutes = currentTime.offset // offset in minutes
  const offsetInHours = offsetInMinutes / 60

  return {
    timezone: tz,
    offset: offsetInHours,
  }
})

// Sort the array by offset (UTC offset)
timezonesWithOffset.sort((a: any, b: any) => {
  if (a.offset === b.offset) {
    return a.timezone.localeCompare(b.timezone) // Sort alphabetically if offsets are equal
  }
  return a.offset - b.offset // Sort by offset
})

timezonesWithOffset.map((tz: any) => {
  timeZoneMap[tz.timezone] = `${tz.timezone.replaceAll('_', ' ').replace('/', ', ')} (UTC${tz.offset >= 0 ? '+' : ''}${
    tz.offset
  }:00)`
})

export default timeZoneMap
